import * as React from 'react';
import parse from 'html-react-parser';

import { View} from '../libs/WebComponents';
import { Props } from '../types/types';

const AppTip = (props: Props) => {

   return (
         <View>
            {props.body?parse(props.body):null}
         </View>
   );
}

export default React.memo(AppTip);

